import {ApplyVoucherRequestType, ApplyVoucherResponseType} from "@CheckOrder/api/types/vouchers/ApplyVoucher.type";
import {setPassengerDataUpdating, setTicket} from "@CheckOrder/reducers/checkOrderSlice";
import {setError} from "@Reducers/pageSlice";
import {OnQueryStartedFunctionAttrType} from "@/types/generic/OnQueryStartedFunctionAttr.type";

export default function applyVoucherQuery(): OnQueryStartedFunctionAttrType<ApplyVoucherRequestType, ApplyVoucherResponseType> {
    return async (request, {dispatch, queryFulfilled}) => {
        dispatch(setPassengerDataUpdating(true))

        try {
            const response = await queryFulfilled

            if (response.meta.response.ok && !!response.data.ticket) {
                dispatch(setTicket({
                    ticket: {
                        ...request.ticket,
                        ...response.data.ticket,
                    },
                    keepPassengerClasses: true,
                }))

                dispatch(setPassengerDataUpdating(false))
            }
        } catch (err) {
            dispatch(setError({
                error: "Voucher couldn't be applied",
                info: `Voucher ${request.voucher_code} failed on ticketCode: ${request.ticket_code}`,
            }))
            dispatch(setPassengerDataUpdating(false))
        }
    }
}